import { render } from "./CosmoLocation.vue?vue&type=template&id=ee22daf6&scoped=true"
import script from "./CosmoLocation.vue?vue&type=script&lang=js"
export * from "./CosmoLocation.vue?vue&type=script&lang=js"

import "./CosmoLocation.vue?vue&type=style&index=0&id=ee22daf6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee22daf6"]])

export default __exports__